import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { getModule } from '@jwp/ott-common/src/modules/container';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import AccountController from '@jwp/ott-common/src/controllers/AccountController';
import { modalURLFromLocation } from '@jwp/ott-ui-react/src/utils/location';
import { formatLocalizedDate } from '@jwp/ott-common/src/utils/formatting';

import LoadingOverlay from '../../../components/LoadingOverlay/LoadingOverlay';
import { useAriaAnnouncer } from '../../AnnouncementProvider/AnnoucementProvider';
import CancelPlan from '@jwp/ott-ui-react/src/components/CancelSubscriptionForm/CancelPlan';
import CheckoutController from '@jwp/ott-common/src/controllers/CheckoutController';

const Cancellation = () => {
  const accountController = getModule(AccountController);
  const checkoutController = getModule(CheckoutController);
  const { t, i18n } = useTranslation('account');
  const announce = useAriaAnnouncer();
  const navigate = useNavigate();
  const location = useLocation();
  const subscription = useAccountStore((s) => s.subscription);
  const [cancelled, setCancelled] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const expirationDateFormatted = subscription?.expiresAt ? formatLocalizedDate(new Date(subscription.expiresAt * 1000), i18n.language) : '';

  const cancelSubscriptionConfirmHandler = async () => {
    setSubmitting(true);
    setError(null);
    try {
      const response = await checkoutController.cancelSwitchSubscription();
      if (response) {
        await accountController.reloadSubscriptions();
        closeHandler();
        setCancelled(true);
      }
    } catch (error: unknown) {
      setError(t('cancel_subscription.unknown_error_occurred'));
    }

    setSubmitting(false);
  };

  const closeHandler = () => {
    navigate(modalURLFromLocation(location, null), { replace: true });
  };

  return (
    <React.Fragment>
      <CancelPlan onConfirm={cancelSubscriptionConfirmHandler} onCancel={closeHandler} submitting={submitting} error={error} />
      {submitting ? <LoadingOverlay transparentBackground inline /> : null}
    </React.Fragment>
  );
};
export default Cancellation;
